import styled from 'styled-components'

export const MainCTA = styled.div.attrs((props: any) => ({
  $isForm: props.$isForm,
}))`
  // only show mac and dot background when not a form CTA
  ${({ theme, $isForm }) => {
    const BackgroundStyle = `
      .MainCTA__Inner {
        &:before {
          content: '';
          position: absolute;
          z-index: -1;
          top: -83px;
          left: -473px;
          width: 869px;
          height: 434px;
          background: url('/steam-img/MainCTA-Mac.svg') no-repeat;
        }

        &:after {
          content: '';
          position: absolute;
          z-index: -1;
          top: 76px;
          right: -237px;
          width: 213px;
          height: 213px;
          background: url('/steam-img/MainCTA-Dot.svg') no-repeat;
        }

        @media screen and (max-width: 1680px) {
          &:before {
            top: -19px;
            left: -530px;
          }

          &:after {
            top: 140px;
            right: -294px;
          }
        }

        ${theme.breakpoints.down('sm')} {
          &:before {
            left: -506px;
          }
        }

        @media screen and (max-width: 360px) {
          &:before {
            left: -541px;
          }
        }
      }
    `
    return !$isForm ? BackgroundStyle : ``
  }}

  width: 100%;
  padding: 128px 24px;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  background: ${({ theme }) => theme.webMktPalette.background.gray};
  z-index: 0;

  .MainCTA__Inner {
    max-width: 906px;
    margin: 0 auto;
    text-align: center;
    position: relative;
  }

  .MainCTA__Title {
    margin-bottom: 24px;
  }

  .MainCTA__Subtitle {
    margin: 0 0 32px;
  }

  .MainCTA__Disclaimer {
    color: rgba(0, 0, 0, 0.3);
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0px;
    line-height: 20px;
    margin-top: 32px;
  }

  .MainCTA__Buttons {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: auto;
    align-items: center;

    .CTA:nth-child(2) {
      margin-left: 24px;
    }
  }

  // Responsive
  @media screen and (max-width: 1680px) {
    padding: 64px 24px;

    .MainCTA__Inner {
      max-width: 792px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    .MainCTA__Title {
      margin-bottom: 16px;
    }
  }

  @media screen and (max-width: 475px) {
    padding-bottom: 64px 16px;

    .MainCTA__Buttons {
      flex-direction: column;
      align-content: center;
      align-items: flex-start;

      .CTA {
        display: flex;
        justify-content: center;
        width: 100%;

        &:first-child {
          margin-bottom: 24px;
        }
        &:nth-child(2) {
          margin-left: 0;
        }
      }
    }
  }
`
